import { useGameMoves } from "@/hooks/useGameMoves"
import { Chessboard as ReactChessboard } from "react-chessboard"

const FrozenBoard = ({ fen }: { fen?: string | null }) => {
  const { game } = useGameMoves()

  return (
    <ReactChessboard
      position={fen ?? game.fen()}
      areArrowsAllowed={false}
      onSquareClick={() => {}}
      autoPromoteToQueen={false}
      onPromotionCheck={() => false}
      customDarkSquareStyle={{
        backgroundColor: "#c56c1a",
      }}
      customLightSquareStyle={{
        backgroundColor: "#ffd17f",
      }}
      onPieceDragBegin={() => {}}
      isDraggablePiece={() => false}
    />
  )
}

export default FrozenBoard
